"use client";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { navItems } from "@/lib/content";
import { site } from "@/lib/site";

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/90 bg-white/95 shadow-sm shadow-slate-200/30 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-3 sm:px-6">
        <Link
          href="/"
          className="inline-flex shrink-0 items-center gap-2.5 transition-opacity hover:opacity-90"
          aria-label={`${site.name} home`}
        >
          <Image
            src="/brand/logo-header.png"
            alt=""
            width={36}
            height={36}
            priority
            className="h-8 w-8 rounded-lg sm:h-9 sm:w-9"
          />
          <span className="font-display text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
            {site.name}
          </span>
        </Link>

        <nav
          className="ml-auto hidden items-center gap-1 lg:flex lg:gap-2"
          aria-label="Primary"
        >
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className="rounded-lg px-2.5 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900 sm:px-3"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={site.repoUrl}
            target="_blank"
            rel="noreferrer"
            className="rounded-xl bg-gradient-to-r from-brand-600 to-teal-600 px-3 py-2 text-sm font-semibold text-white shadow-md shadow-emerald-500/25 transition hover:shadow-lg sm:px-4"
          >
            GitHub
          </a>
        </nav>

        <button
          className="ml-auto rounded-lg p-2 text-slate-600 transition hover:bg-slate-100 lg:hidden"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-slate-100 bg-white px-4 py-3 lg:hidden"
          aria-label="Mobile"
        >
          <ul className="space-y-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li className="pt-1">
              <a
                href={site.repoUrl}
                target="_blank"
                rel="noreferrer"
                className="block rounded-xl bg-gradient-to-r from-brand-600 to-teal-600 px-3 py-2.5 text-center text-sm font-semibold text-white"
              >
                View on GitHub
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
